import { render } from "./RewardSelect.vue?vue&type=template&id=e212c7de"
import script from "./RewardSelect.vue?vue&type=script&lang=ts"
export * from "./RewardSelect.vue?vue&type=script&lang=ts"
script.render = render

export default script